import { Button, Typography } from "@mui/material";
import * as React from "react";
import { withRouter } from "react-router-dom";

class Error404PageWrapped extends React.Component<any, any> {
    onHomeClick() {
        this.props.history.push("/");
    }

    render() {
        return <div className="contentPadding">
            <Typography variant="h3" gutterBottom>
                404: The page you are looking for isn’t here
            </Typography>
            <Typography variant="body2" component="p">
                You tried some shady route 😮
            </Typography>

            <div style={{ marginTop: 40 }}>
                <Button disableElevation variant="contained" color="primary" size="small" onClick={() => this.onHomeClick()}>
                    Back to home
                </Button>
            </div>
        </div>
    }
}
export const Error404Page = withRouter(Error404PageWrapped);
